import { FailedPlaceholder } from '@bingads-webui-campaign-react/video-status-placeholder-pure-component';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getPlaceholderStyle } from './styles';

export const FailedPlaceholderWithStyle = withDefaultStyles(FailedPlaceholder, getPlaceholderStyle);
